import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPage.css';

const PrivacyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-page">
      <div className="container">
        <button className="back-link" onClick={() => navigate('/')}>
          ← Retour à l'accueil
        </button>
        
        <h1 className="page-title">Politique de Confidentialité</h1>
        <p className="last-update">Dernière mise à jour : 10 décembre 2025</p>

        <div className="privacy-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              MyAidgent s'engage à protéger la confidentialité et la sécurité de vos données personnelles. 
              Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons 
              vos informations lorsque vous utilisez notre site web.
            </p>
          </section>

          <section>
            <h2>2. Données collectées</h2>
            <p>Nous collectons les informations suivantes lorsque vous utilisez notre site :</p>
            <ul>
              <li><strong>Informations de contact :</strong> nom, prénom, adresse e-mail, numéro de téléphone (optionnel)</li>
              <li><strong>Informations professionnelles :</strong> nom de l'entreprise, rôle, nombre d'employés</li>
              <li><strong>Informations sur votre projet :</strong> besoins, description de votre problématique</li>
              <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées</li>
            </ul>
          </section>

          <section>
            <h2>3. Utilisation des données</h2>
            <p>Vos données personnelles sont utilisées pour :</p>
            <ul>
              <li>Répondre à vos demandes de devis et de contact</li>
              <li>Vous fournir des informations sur nos services</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section>
            <h2>4. Base légale du traitement</h2>
            <p>
              Le traitement de vos données personnelles est fondé sur :
            </p>
            <ul>
              <li>Votre consentement lors de la soumission du formulaire</li>
              <li>L'exécution de mesures précontractuelles (demande de devis)</li>
              <li>Notre intérêt légitime à améliorer nos services</li>
            </ul>
          </section>

          <section>
            <h2>5. Partage des données</h2>
            <p>
              Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers à des fins commerciales. 
              Vos données peuvent être partagées uniquement avec :
            </p>
            <ul>
              <li>Nos prestataires de services techniques (hébergement, email)</li>
              <li>Les autorités légales si requis par la loi</li>
            </ul>
          </section>

          <section>
            <h2>6. Conservation des données</h2>
            <p>
              Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles 
              elles ont été collectées, et conformément aux obligations légales applicables (généralement 3 ans 
              pour les prospects).
            </p>
          </section>

          <section>
            <h2>7. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour 
              protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction :
            </p>
            <ul>
              <li>Chiffrement des communications (HTTPS)</li>
              <li>Accès restreint aux données personnelles</li>
              <li>Surveillance et audit réguliers de nos systèmes</li>
            </ul>
          </section>

          <section>
            <h2>8. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul>
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@myaidgent.com">contact@myaidgent.com</a>
            </p>
          </section>

          <section>
            <h2>9. Cookies</h2>
            <p>
              Notre site utilise des cookies techniques nécessaires à son bon fonctionnement. Nous n'utilisons 
              pas de cookies publicitaires ou de suivi tiers sans votre consentement.
            </p>
          </section>

          <section>
            <h2>10. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
              Les modifications seront publiées sur cette page avec une nouvelle date de mise à jour.
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>
              Pour toute question concernant cette politique de confidentialité ou le traitement de vos données 
              personnelles, vous pouvez nous contacter :
            </p>
            <ul>
              <li><strong>Email :</strong> <a href="mailto:contact@myaidgent.com">contact@myaidgent.com</a></li>
              <li><strong>Site web :</strong> <a href="https://www.myaidgent.com">www.myaidgent.com</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
